export const WALLPAPERS_ARE_LOADING = 'WALLPAPERS_ARE_LOADING'
export const WALLPAPERS_LOADED = 'WALLPAPERS_LOADED'
export const WALLPAPERS_FAILED = 'WALLPAPERS_FAILED'

export const SELECT_WALLPAPER = 'SELECT_WALLPAPER'
export const REMOVE_WALLPAPER = 'REMOVE_WALLPAPER'

export const START_GAUGING_UP = 'START_GAUGING_UP'
export const REFRESH_GAUGE = 'REFRESH_GAUGE'
export const ACCEPT_GAUGE = 'ACCEPT_GAUGE'
export const REFRESH_REAL_METER = 'REFRESH_REAL_METER'



// WEBPACK FOOTER //
// ./src/constants/wallpapersActions.js